exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader-container[data-v-5200b887]{position:fixed;top:0;width:100%;height:100%;background-color:#fdf8f5}.logo[data-v-5200b887]{position:absolute;top:calc(50% - 60px);left:calc(50% - 100px)}.path[data-v-5200b887]{stroke-dasharray:1322;stroke-dashoffset:1322;animation:dash-data-v-5200b887 7s linear alternate infinite}@keyframes dash-data-v-5200b887{0%{stroke-dashoffset:1322}to{stroke-dashoffset:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5200b887","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layout/loader.vue
// module id = 308
// module chunks = 0